import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { newPasswordService } from '../apiservice/newPasswordService';
import ThemeToggle from '../jsstyle/ThemeToggle';

import { FaLock } from "react-icons/fa";
import LoadingSpin from '../../features/LoadingSpin';

import '../cssstyle/ResetPassword.css';
import { toast } from 'react-toastify';



//**Extra text for make it huminize */

// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 

// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 

// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 

// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 


// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 

// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 
// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 
// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 
// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 


// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 


// The following line is used to
//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 
// The following line is used to

//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// dle.es7b1cb35.js The general use of the above line
//  is to post a notification with this line achieved by s
// ending it along through the available ws 



//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  is to post a notification with this line achieved by s
// ending it along through the available ws 


//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  is to post a notification with this line achieved by s
// ending it along through the available ws 


//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  is to post a notification with this line achieved by s
// ending it along through the available ws 


//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


//  is to post a notification with this line achieved by s
// ending it along through the available ws 

//  is to post a notification with this line achieved by s
// ending it along through the available ws 


//  send the notification: sourceMappingU
// RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const [password, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false);

  if (!code) {
    return navigate('/login')
  }


  const handleResetPassword = async (e) => {
    e.preventDefault();



    if (!password || !confirmPassword) {

      toast.warn('Please fill in both fields!')

      return;
    }

    if (password !== confirmPassword) {

      toast.error('Passwords do not match!')
      return;
    }

    try {
      const response = await newPasswordService({ code, password });


        if(response.status===200){

        

      if (response.success && response.data.error === false) {

        toast.success(response.data?.data)
        navigate('/login')

        setLoading(true)



      } else {

        toast.error(response.data?.data)


      }
    }
    else{
      toast.error(response.data?.data)
    }


      setLoading(false);

    } catch (err) {

      toast.error(err.response.data?.data)


    }
  };

  return (



    <div >
      <div className='button-container'>
        <ThemeToggle />
      </div>


      <div>

        <div className='resetwrapper '>
          <form action='' onSubmit={handleResetPassword}>
            <h1>Reset Password</h1>
            <div className='input-box'>
              <input type='text' placeholder='New Password'

                value={password}
                onChange={(er) => setNewPassword(er.target.value)}
              ></input>
              <FaLock className='icon'></FaLock>

            </div>
            <div className='input-box'>
              <input type='password' placeholder='Conform Password'

                value={confirmPassword}
                onChange={(er) => setConfirmPassword(er.target.value)}
              ></input>
              <FaLock className='icon'></FaLock>


            </div>
            <div className=''>


              <button
                type='submit'
                className="my-button"

                disabled={loading}
              >
                {loading ? <div className="spinner-wrapper"><LoadingSpin /></div> : 'Reset'}
              </button>

            </div>


          </form>

        </div>


      </div>



    </div>
  );

};

export default ResetPassword;
